"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PURCHASE_ORDER_STATUSES_PRE_APPROVAL = exports.PURCHASE_ORDER_STATUSES_APPROVER_READ = exports.PURCHASE_ORDER_STATUSES_PROCUREMENT_RIGHT_READ = exports.PURCHASE_ORDER_STATUSES_UPDATE_FORBIDDEN = exports.PurchaseOrderStatusEnum = void 0;
var PurchaseOrderStatusEnum;
(function (PurchaseOrderStatusEnum) {
    PurchaseOrderStatusEnum[PurchaseOrderStatusEnum["DRAFT"] = 100] = "DRAFT";
    PurchaseOrderStatusEnum[PurchaseOrderStatusEnum["WAITING_FOR_APPROVAL"] = 200] = "WAITING_FOR_APPROVAL";
    PurchaseOrderStatusEnum[PurchaseOrderStatusEnum["PROCUREMENT"] = 300] = "PROCUREMENT";
    PurchaseOrderStatusEnum[PurchaseOrderStatusEnum["FULFILLMENT"] = 400] = "FULFILLMENT";
    PurchaseOrderStatusEnum[PurchaseOrderStatusEnum["CALCULATE_LINE_ITEMS"] = 500] = "CALCULATE_LINE_ITEMS";
    PurchaseOrderStatusEnum[PurchaseOrderStatusEnum["CONFIRMATION"] = 600] = "CONFIRMATION";
    PurchaseOrderStatusEnum[PurchaseOrderStatusEnum["COMPLETED"] = 700] = "COMPLETED";
    PurchaseOrderStatusEnum[PurchaseOrderStatusEnum["FAILED"] = 800] = "FAILED";
})(PurchaseOrderStatusEnum || (exports.PurchaseOrderStatusEnum = PurchaseOrderStatusEnum = {}));
exports.PURCHASE_ORDER_STATUSES_UPDATE_FORBIDDEN = Object.freeze([
    PurchaseOrderStatusEnum.FULFILLMENT,
    PurchaseOrderStatusEnum.CONFIRMATION,
    PurchaseOrderStatusEnum.COMPLETED,
    PurchaseOrderStatusEnum.FAILED,
]);
/**
 * States allowed for user to read when given this right
 *
 * See: @see RightsEnum.PURCHASE_ORDER__PROCUREMENT__READ
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
exports.PURCHASE_ORDER_STATUSES_PROCUREMENT_RIGHT_READ = Object.freeze([
    PurchaseOrderStatusEnum.PROCUREMENT,
    PurchaseOrderStatusEnum.FULFILLMENT,
    PurchaseOrderStatusEnum.CALCULATE_LINE_ITEMS,
    PurchaseOrderStatusEnum.CONFIRMATION,
    PurchaseOrderStatusEnum.COMPLETED,
]);
exports.PURCHASE_ORDER_STATUSES_APPROVER_READ = Object.freeze([
    PurchaseOrderStatusEnum.WAITING_FOR_APPROVAL,
    PurchaseOrderStatusEnum.PROCUREMENT,
    PurchaseOrderStatusEnum.FULFILLMENT,
    PurchaseOrderStatusEnum.CALCULATE_LINE_ITEMS,
    PurchaseOrderStatusEnum.CONFIRMATION,
    PurchaseOrderStatusEnum.COMPLETED,
    PurchaseOrderStatusEnum.FAILED,
]);
exports.PURCHASE_ORDER_STATUSES_PRE_APPROVAL = Object.freeze([
    // preserve line break
    PurchaseOrderStatusEnum.DRAFT,
    PurchaseOrderStatusEnum.WAITING_FOR_APPROVAL,
]);
